import { useSwiper, useSwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";
import LearningGuide from "./LearningGuide";

export default function () {
  const swiperSlide = useSwiperSlide();
  const swiper = useSwiper();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    swiper.enable();
    if (swiper.support.touch) {
      swiper.allowTouchMove = true;
    }
  });
  const onNext = () => {
    swiper.slideNext();
  };

  if (!swiperSlide.isActive) {
    return <></>;
  }

  return (
    <>
      <img
        onClick={() => {
          setIsDialogOpen(true);
        }}
        style={{ position: "absolute", top: "100px", left: "1060px" }}
        src="images/00/btn_preview.png"
      ></img>
      {isDialogOpen ? (
        <>
          <LearningGuide
            onClose={() => {
              setIsDialogOpen(false);
            }}
          />
        </>
      ) : (
        <></>
      )}
      <div
        style={{
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          top: "207px",
          left: "50%",
          transform: "translate(-50%, -0%)",
        }}
      >
        <img src="images/00/title.png"></img>
      </div>

      <div
        style={{
          position: "absolute",
          top: "760px",
          left: "50%",
          transform: "translate(-50%, -0%)",
        }}
      >
        <img src="images/00/btn_arrow.png" onClick={onNext}></img>
      </div>
    </>
  );
}
